const category = {
  digital: {
    title: "数字藏品",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "领略独一无二的数字藏品",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/digital/purchase?navhide=1&lotteryId={id}",
  },
  collection: {
    title: "数字周边",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "找寻属于你的数字周边",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/v2/card/collection?hybrid_set_header=2&act_id={id}",
  },
  suit: {
    title: "个性装扮",
    iconURL: require("./assets/pinkDress.svg"),
    subTitle: "找寻属于你的个性装扮",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/suit/detail?navhide=1&id={id}",
  },
  dlc: {
    title: "数字周边",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "找寻属于你的数字周边",
    iframeURLPrefix:
      "https://www.bilibili.com/h5/mall/digital-card/home?navhide=1&hybrid_set_header=2&-Abrowser=live&act_id={id}&lottery_id={lottery_id}&window_params={window_params}",
  },
  "garb-summer": {
    title: "装扮赏·仲夏幻想",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://ff-uat-activity.bilibili.com/preview/redpack/activity-M0LBEFrfUD.html?navhide=1",
  },
  "garb-winter-2023": {
    title: "装扮赏·琉晶之礼",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-C32RAXikal.html?navhide=1&act_id={id}",
  },
  wish: {
    title: "装扮祈愿会",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-3cc5x8HFHJ.html?navhide=1&hybrid_set_header=2&-Abrowser=live&act_id={id}",
  },
  "gift-202401": {
    title: "龙年金运，点卡成金",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://m.bilibili.com/doria/card-exchange.html?exchange_act_id={id}",
  },
  "gift-package-202402": {
    title: "新春豪礼",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-rzNlwXhoos.html?navhide=1&act_id={id}",
  },
  "gift-202405": {
    title: "礼包活动",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-PpTLCPHRqO.html?navhide=1",
  },
  "garb-common-wish-2024": {
    title: "装扮祈愿会",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-0LPHv03rNO.html?navhide=1&_no_={id}",
  },
  "garb-reward-202406": {
    title: "装扮赏·星时影迹",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-eOz6tP3zgP.html?navhide=1&act_id={id}",
  },
  "rank-act": {
    title: "收藏集榜单活动",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb-rank-list.html?act_id={id}",
  },
  "gift-202407": {
    title: "箱中灵羽",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-e5RONdFsV5.html?navhide=1",
  },
  "gift-202410": {
    title: "幻影新生",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-WqLvIDsEaj.html?navhide=1",
  },
  "out-avatar-202409": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/redpack/activity-7B5cb50pOi.html?navhide=1",
  },
  "gift-202411": {
    title: "暮色战姬",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-qYXsg3SiVs.html?navhide=1",
  },
  "garb-5th-main": {
    title: "绘梦记",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-Kd0pTqZEno.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-report": {
    title: "绘梦录",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-T4bmPeNPgK.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-jigsaw": {
    title: "森之绮境",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-w5TcB7eaWh.html?navhide=1&f_source=plat&from=ad.task",
  },
  "garb-5th-treasure": {
    title: "拾光藏宝",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-BQdBI7u3ir.html?navhide=1&f_source=plat&from=ad.task",
  },
  "spring-202501": {
    title: "蛇来运转",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/activity-VevSUw04Ue.html?navhide=1",
  },
  "out-avatar-202503": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-tSpNtU5sLl.html?navhide=1",
  },
  "gift-202505": {
    title: "圣羽裁决",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-LmAT7gEHgb.html?navhide=1",
  },
  "gift-202503": {
    title: "祈梦之境",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-2JbHAg1O2B.html?navhide=1",
  },
  "gift-202507": {
    title: "月相共鸣",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/garb/activity-4cAhklGXr4.html?navhide=1",
  },
  "out-avatar-202509": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/PQj8Oh2qUIlA0oBh.html?navhide=1",
  },
  "gift-202509": {
    title: "破空之魂",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/8P8PbWDA6pFzPGvd.html?navhide=1",
  },
  "flip-card-202512": {
    title: "开牌见鸽",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/4986vLZHjku2FnVA.html?navhide=1",
  },
  "entity-exchange-202512": {
    title: "毛茸茸的冬日魔法",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/h4FkmTxeFzqi8oeq.html",
  },
  "garb-contest-202512": {
    title: "人人都是搭配大师",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/DZ89ovqQ9eTplR9i.html?navhide=1",
  },
  "equity-link-home": {
    title: "个性装扮",
    iconURL: require("./assets/pinkDress.svg"),
    subTitle: "找寻属于你的个性装扮",
    iframeURLPrefix: 
      "https://www.bilibili.com/h5/mall/equity-link/home?item_id={id}&part={part}&vmid={vmid}&isdiy={isdiy}&chargeplus={chargeplus}&navhide=1&local=1",
  },
  "equity-link-collect-home": {
    title: "个性装扮",
    iconURL: require("./assets/pinkDress.svg"),
    subTitle: "找寻属于你的个性装扮",
    iframeURLPrefix: 
      "https://www.bilibili.com/h5/mall/equity-link/collect-home?item_id={id}&part={part}&vmid={vmid}&isdiy={isdiy}&navhide=1&local=1",
  },
  "spring-202602": {
    title: "马上有福",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/WIdgCWjSiAJr1aWh.html?navhide=1",
  },
  "out-avatar-202603": {
    title: "集齐全图鉴，赢限定出框",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/RN7qfgJ1tZls9wpm.html?navhide=1",
  },
  "gift-202604": {
    title: "樱风恋语",
    iconURL: require("./assets/diamond.svg"),
    subTitle: "",
    iframeURLPrefix:
      "https://www.bilibili.com/blackboard/era/AklgYHlHXjU7eOeE.html?navhide=1",
  },
};
export { category };
